// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__8Rsl1","header":"PatientQuestionnaire_header__Ad-Rs","info":"PatientQuestionnaire_info__3PUFD"};